import {
  Button,
  Card,
  Form,
  message,
  Modal,
  Popconfirm,
  Space,
  Tabs,
  Row,
  Col,
  Input,
} from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import TableComponent from "../../common/TableComponent";
import AddUser from "./AddUser";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

// import noImage from "../../../assests/images/no-image.png";
function UserTable() {
  const [activeTab, setActiveTab] = useState(1);
  const [showDelete, setShowDelete] = useState(false);
  const [confirmDeletePCLoading, setConfirmDeletePCLoading] = useState(false);
  const [confirmReactivatePCLoading, setConfirmReactivatePCLoading] =
    useState(false);
  // const [dropdownUsers, setDropdownUsers] = useState([]);
  const columns = [
    {
      title: "User Name",
      dataIndex: "username",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Role",
      dataIndex: "role",
    },

    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          {activeTab !== "deactivated" && (
            <Space>
              <Button size="small" onClick={() => editRecord(record)}>
                <EditOutlined />
              </Button>
              <Button
                size="small"
                onClick={() => {
                  setSelectedRecord(record);
                  setShowDelete(true);
                }}
              >
                <DeleteOutlined style={{ color: "red" }} />
              </Button>
              <Button size="small" onClick={() => updatePasswordRecord(record)}>
                Update Password
              </Button>
            </Space>
          )}
          {activeTab === "deactivated" && (
            <Space>
              <Popconfirm
                title="Reactivate User"
                description={`Are you sure to reactivate ${record.username}?`}
                onConfirm={() => reactivateRecord(record)}
                trigger={"click"}
                okButtonProps={{
                  loading: confirmReactivatePCLoading,
                }}
                placement="rightTop"
              >
                <Button size="small">Reactivate</Button>
              </Popconfirm>
            </Space>
          )}
        </>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    `/config/user?pageNumber=${1}&role_id=1`,
    null,
    API_METHODS.GET
  );
  // const [usersForDropdown, getUsersForDropdown] = useApi(
  //   `/config/user/dropdown?usertype=admin`,
  //   null,
  //   API_METHODS.GET
  // );

  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState();
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteResponse, deleteRequest] = useApi();
  const [visibleUpdatePassword, setVisibleUpdatePassword] = useState(false);
  const [updatePasswordResponse, updatePasswordRequest] = useApi();
  const [form] = Form.useForm();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [deactivatedUsersData, getDeactivatedUsers] = useApi(
    `/config/user/deactivated?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );
  const [reactivateResponse, reactivateRequest] = useApi();

  // useEffect(() => {
  //   if (clientConfig.data) {
  //     setDataToLocalStorage("clientConfig", clientConfig.data);
  //   }
  // }, [clientConfig]);

  useEffect(() => {
    getRequest();
    // getUsersForDropdown();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  // useEffect(() => {
  //   if (
  //     !isEmpty(usersForDropdown) &&
  //     !isEmpty(usersForDropdown.data) &&
  //     !usersForDropdown.isLoading
  //   ) {
  //     const data =
  //       usersForDropdown.data !== BLANK_VALUE ? usersForDropdown.data : [];
  //     setDropdownUsers(data);
  //   }
  // }, [usersForDropdown]);

  useEffect(() => {
    const data =
      deactivatedUsersData.data !== BLANK_VALUE
        ? deactivatedUsersData.data
        : [];
    const pagination =
      deactivatedUsersData.pagination !== BLANK_VALUE
        ? deactivatedUsersData.pagination
        : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [deactivatedUsersData]);

  useEffect(() => {
    if (deleteResponse.data && !deleteResponse.isLoading) {
      getRequest();
      setCurrentPage(1);
      // getUsersForDropdown();
      setActiveTab(1);
      setConfirmDeletePCLoading(false);
      setSelectedRecord(null);
      setShowDelete(false);
      message.success("User Deleted successfully.");
    }
  }, [deleteResponse]);

  useEffect(() => {
    if (reactivateResponse.data && !reactivateResponse.isLoading) {
      getRequest();
      setCurrentPage(1);
      // getUsersForDropdown();

      setActiveTab(1);
      setConfirmReactivatePCLoading(false);
      message.success("User Reactivated successfully.");
    }
  }, [reactivateResponse]);

  useEffect(() => {
    if (updatePasswordResponse.data && !updatePasswordResponse.isLoading) {
      setVisibleUpdatePassword(false);
      setSelectedRecord(null);
      getRequest();
      setCurrentPage(1);
      // getUsersForDropdown();

      form.resetFields();
      setActiveTab(1);
      message.success("User Password updated successfully.");
    }
  }, [updatePasswordResponse]);

  const handleAddUser = (isUpdated) => {
    const flag = visible ? false : true;
    setVisible(flag);
    if (isUpdated === true) {
      getRequest();
      // getUsersForDropdown();
      setCurrentPage(1);
      setActiveTab(1);
    }
  };

  const handleEditUser = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest();
      // getUsersForDropdown();
      setCurrentPage(1);
      setActiveTab(1);
    }
  };

  const editRecord = (record) => {
    setVisibleEdit(true);
    setSelectedRecord(record);
  };

  const deleteOk = (record) => {
    form
      .validateFields()
      .then((values) => {
        let body = {
          date: values.date,
        };
        setConfirmDeletePCLoading(true);
        deleteRequest(body, API_METHODS.DELETE, `/config/user/${record.id}`);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const reactivateRecord = (record) => {
    setConfirmReactivatePCLoading(true);
    reactivateRequest(
      null,
      API_METHODS.PUT,
      `/config/user/reactivate/${record.id}`
    );
  };

  const onPaginationChange = (page) => {
    if (activeTab === "deactivated") {
      getDeactivatedUsers(
        null,
        API_METHODS.GET,
        `/config/user/deactivated?pageNumber=${page.current}`
      );
    } else {
      getRequest(
        null,
        API_METHODS.GET,
        `/config/user?pageNumber=${page.current}&role_id=${activeTab}`
      );
    }
    setCurrentPage(page.current);
  };

  const updatePasswordRecord = (record) => {
    setVisibleUpdatePassword(true);
    setSelectedRecord(record);
  };

  const updatePassword = () => {
    form.validateFields().then((values) => {
      if (selectedRecord) {
        updatePasswordRequest(
          values,
          API_METHODS.PUT,
          `/config/user/password/${selectedRecord && selectedRecord.id}`
        );
      }
    });
  };

  const handleCancelUpdatePassword = () => {
    setVisibleUpdatePassword(false);
    setSelectedRecord(null);
    form.resetFields();
  };
  // const filterResults = () => {
  //   const values = form.getFieldsValue();
  //   setCurrentPage(1);
  //   if (activeTab === "deactivated") {
  //     getDeactivatedUsers(
  //       null,
  //       API_METHODS.GET,
  //       `/config/user/deactivated?pageNumber=${1}`
  //     );
  //   } else {
  //     getRequest(null, API_METHODS.GET, `/config/user?pageNumber=${1}`);
  //   }
  //   // let url = `/config/site?pageNumber=${1}`;
  //   // if (activeTab === "deactivated") {
  //   //   url = `/config/site/deactivated?pageNumber=${1}`;
  //   //   url = values.dbTableSiteId
  //   //     ? url + `&dbTableSiteId=${values.dbTableSiteId}`
  //   //     : url;
  //   //   getDeactivatedSites(null, API_METHODS.GET, url);
  //   // } else {
  //   //   url = values.dbTableSiteId
  //   //     ? url + `&dbTableSiteId=${values.dbTableSiteId}`
  //   //     : url;
  //   //   getRequest(null, API_METHODS.GET, url);
  //   // }
  // };

  // const resetResult = () => {
  //   setCurrentPage(1);
  //   form.resetFields();
  //   setActiveTab("admin");
  //   getRequest();
  //   // getUsersForDropdown();
  // };

  const items = [
    {
      key: 1,
      label: "Admin",
      children: (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={responseData.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      ),
    },
    {
      key: 2,
      label: "Sales",
      children: (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={responseData.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      ),
    },
    {
      key: "deactivated",
      label: "Deactivated Users",
      children: (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={deactivatedUsersData.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      ),
    },
  ];

  const onTabChange = (key) => {
    setActiveTab(key);
    setCurrentPage(1);
    form.resetFields();
    if (key !== "deactivated") {
      getRequest(
        null,
        API_METHODS.GET,
        `/config/user?pageNumber=${1}&role_id=${key}`
      );
      // getUsersForDropdown(
      //   null,
      //   API_METHODS.GET,
      //   `/config/user/dropdown?usertype=${key}`
      // );
    } else {
      // getUsersForDropdown(
      //   null,
      //   API_METHODS.GET,
      //   `/config/user/dropdown?usertype=deactivated`
      // );
      getDeactivatedUsers();
    }
  };

  return (
    <Card
      title="Users"
      extra={
        <Button type="primary" onClick={handleAddUser}>
          Add User
        </Button>
      }
    >
      <Tabs
        defaultActiveKey="users"
        activeKey={activeTab}
        items={items}
        onChange={onTabChange}
      />

      {visible && (
        <AddUser visible={visible} close={handleAddUser} edit={false} />
      )}
      {visibleEdit && (
        <AddUser
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditUser}
          edit={true}
        />
      )}
      {visibleUpdatePassword && (
        <Modal
          title={`Update Password for- ${selectedRecord.username}`}
          open={visibleUpdatePassword}
          onOk={updatePassword}
          onCancel={handleCancelUpdatePassword}
          width={800}
          okText="Save"
          destroyOnClose={true}
        >
          <Form layout="vertical" form={form}>
            <Row>
              <Col lg={16} md={16} sm={24} xs={24}>
                <Form.Item
                  name="password"
                  label="New Password"
                  rules={[
                    { required: true, message: "New Password is required." },
                    {
                      max: 20,
                      message:
                        "New Password should be maximum of 20 characters.",
                    },
                  ]}
                >
                  <Input placeholder="Password" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      )}
      {showDelete && (
        <Modal
          title="Delete User"
          open={showDelete}
          onOk={() => deleteOk(selectedRecord)}
          okText="Yes"
          trigger={"hover"}
          okButtonProps={{
            loading: confirmDeletePCLoading,
          }}
          placement="rightTop"
          onCancel={() => setShowDelete(false)}
        >
          Are you sure to delete <b>{selectedRecord.username}?</b>
        </Modal>
      )}
    </Card>
  );
}

export default UserTable;
